import africaSupportedCountryMapJson from './africaSupportedCountryMap.json'

// Map of supported African country ISO codes to their URL names. Kept in JSON so server.js can read it too.
export const africaSupportedCountryMap = africaSupportedCountryMapJson

// Array of supported African country codes (derived from map keys)
export const africaSupportedCountryCodes = Object.keys(africaSupportedCountryMap)

// Array of URL names for all supported African countries
export const africaSupportedCountryNames = Object.values(africaSupportedCountryMap)

// Array of readable country names
export const africaCountryDisplayNames = [
  'Angola',
  'Benin',
  'Botswana',
  'Burkina Faso',
  'Burundi',
  'Cameroon',
  'Cabo Verde',
  'Central African Republic',
  'Chad',
  'Comoros',
  'Congo',
  "Côte d'Ivoire",
  'Democratic Republic Of The Congo',
  'Djibouti',
  'Equatorial Guinea',
  'Eritrea',
  'Ethiopia',
  'Gabon',
  'Gambia',
  'Ghana',
  'Guinea',
  'Guinea Bissau',
  'Kenya',
  'Lesotho',
  'Liberia',
  'Madagascar',
  'Malawi',
  'Mali',
  'Mauritania',
  'Mauritius',
  'Mozambique',
  'Namibia',
  'Niger',
  'Nigeria',
  'Reunion',
  'Rwanda',
  'Sao Tome And Principe',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Somalia',
  'South Sudan',
  'Eswatini',
  'Tanzania',
  'Togo',
  'Uganda',
  'South Africa',
  'Zambia',
  'Zimbabwe',
]
